
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storagecontainerprices",
      function () {
        return require("private-next-pages/storagecontainerprices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storagecontainerprices"])
      });
    }
  